// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3xckk","label":"Category_label__NN9Pl","content":"Category_content__jnHLX","header":"Category_header__gYLzh","location":"Category_location__30Ppr"};